module.exports = __webpack_public_path__ + "img/trendyol-express.d40c634f.png";